export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_760___MOVEMENT': '% Movement',
    '_731___OPPORTUNITY_ALIGNMENT': '% Opportunity Alignment',
    '_780___OF_TEAM_OPP_ITEMS': '% of Team Opp Items',
    '_767___TO_GOAL': '% to Goal',
    '_768___TO_TARGET': '% to Target',
    '_718___NOTE__COMBINED___IS_70__30_DAY_VARIANCE_AND_30__WTD_VARIANCE': '* Note: Combined % is 70% 30-Day Variance and 30% WTD Variance',
    '_734__1ST_DIAG': '1st Diag',
    '_736__1ST_FOLLOW_UP': '1st Follow Up',
    '_737__2ND_FOLLOW_UP': '2nd Follow Up',
    '_714__30_DAY': '30 Day',
    '_725_ACTUAL': 'Actual',
    '_817_BAND_NAME': 'Band Name',
    '_730_CAO': 'CAO',
    '_732_CPC': 'CPC',
    '_763_CLOSE': 'Close',
    '_795_CLOSE_TO_TARGET': 'Close to Target',
    '_745_COACHING_CYCLE_PERFORMANCE': 'Coaching Cycle Performance',
    '_716_COMBINED': 'Combined',
    '_784_COMPAS': 'Compas',
    '_728_COMPLETION': 'Completion',
    '_738_COMPLETION__MET_OR_UPDATE_': 'Completion (Met or Update)',
    '_759_CURRENT_CLASS': 'Current Class',
    '_733_CURRENT_OPPS': 'Current Opps',
    '_740_CURRENT_PERFORMANCE': 'Current Performance',
    '_758_CURRENT_SCORECARD': 'Current Scorecard',
    '_719_CYCLES': 'Cycles',
    '_746_DETAILS': 'Details',
    '_712_EXPECTED_OPPORTUNITIES_FOR_THE_MONTH___VALUE_': 'Expected Opportunities for the month: {{value}}',
    '_796_FAVOURABLE': 'Favourable',
    '_781_GENERAL_COMPLIANCE': 'General Compliance',
    '_721_GOAL': 'Goal',
    '_770_GOAL___30_DAYS': 'Goal > 30 Days',
    '_741_GOAL_MET': 'Goal Met',
    '_735_GOAL_STARTED': 'Goal Started',
    '_742_GOAL_UPDATED': 'Goal Updated',
    '_792_GOALS___30_DAYS': 'Goals > 30 Days',
    '_798_MI2': 'MI2',
    '_791_MEETING_GOAL': 'Meeting Goal',
    '_713_METRIC': 'Metric',
    '_527_METRICS': 'Metrics',
    '_761_MOVEMENT_CLASS': 'Movement Class',
    '_771_MY_PERFORMANCE': 'My Performance',
    '_842_N_A': 'N/A',
    '_53_NAME': 'Name',
    '_803_NAME_': 'Name:',
    '_793_NO_ACTIVE_JOURNALS': 'No Active Journals',
    '_739_NO_COACHING_FOUND': 'No Coaching Found',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_769_NOT_MEETING_GOAL': 'Not Meeting Goal',
    '_805_OPP__': 'Opp #',
    '_779_OPP_ITEMS': 'Opp Items',
    '_744_OPPORTUNITIES_FOR__NAME_': 'Opportunities for {{name}}',
    '_797_OPPORTUNITY_ALIGNMENT': 'Opportunity Alignment',
    '_786_OPPORTUNITY_METRIC': 'Opportunity Metric',
    '_772_PEER_PERFORMANCE': 'Peer Performance',
    '_765_PEERS__BASED_ON_YOUR_CURRENT_SUPERGROUP_PERFORMANCE': 'Peers: Based on your current SuperGroup performance',
    '_134_PERFORMANCE': 'Performance',
    '_722_PERFORMANCE_AT_END_OF_CYCLE': 'Performance at End of Cycle',
    '_720_PERFORMANCE_AT_START_OF_CYCLE': 'Performance at Start of Cycle',
    '_785_PERFORMER': 'Performer',
    '_773_PERIOD': 'Period',
    '_778_PERSON': 'Person',
    '_801_PILLARS': 'Pillars',
    '_762_POINTS': 'Points',
    '_782_POLICY___AUTO': 'Policy - Auto',
    '_783_POLICY___RESI': 'Policy - Resi',
    '_757_PREVIOUS_CLASS_': 'Previous Class<',
    '_756_PREVIOUS_SCORECARD': 'Previous Scorecard',
    '_788_QUANTITY': 'Quantity',
    '_724_QUEUE_LEVEL': 'Queue Level',
    '_777_RANK': 'Rank',
    '_774_S_G_RANK': 'S/G Rank',
    '_752_SCORE': 'Score',
    '_806_SCORE_': 'Score:',
    '_776_SCORECARD_NAME': 'Scorecard Name',
    '_717_SCORECARD_WEIGHT': 'Scorecard Weight',
    '_802_SCORECARD___SUBTITLE_': 'Scorecard: {{subtitle}}',
    '_75_START_DATE': 'Start Date',
    '_127_STATUS': 'Status',
    '_787_SUGGESTED_FOCUS': 'Suggested Focus',
    '_743_SUMMARY': 'Summary',
    '_67_SUPERGROUP': 'SuperGroup',
    '_800_SUPERGROUP_RANKING': 'SuperGroup Ranking',
    '_804_SUPERGROUP_': 'SuperGroup:',
    '_726_TARGET': 'Target',
    '_729_TEAM_MEMBER': 'Team Member',
    '_727_TEAM_MEMBERS': 'Team Members',
    '_794_UNFAVOURABLE': 'Unfavourable',
    '_102_USER_NAME': 'User Name',
    '_789_VIEW': 'View',
    '_715_WTD': 'WTD',
    '_790_WITH_ACTIVE_JOURNALS': 'With Active Journals',
    '_764_YOU__BASED_ON_YOUR_PERFORMANCE': 'You: Based on your performance',
    '_723_OVERALL': 'overall',
    '_709_DATE_RANGE': 'Date Range'
};
